import { render, staticRenderFns } from "./ListaFaixaAno.vue?vue&type=template&id=0592f73d"
import script from "./ListaFaixaAno.vue?vue&type=script&lang=js"
export * from "./ListaFaixaAno.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports